"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderModeServiceV1 = void 0;
class RenderModeServiceV1 {
    constructor(renderMode) {
        this.renderMode = renderMode;
    }
    getRenderMode() {
        return this.renderMode;
    }
}
exports.RenderModeServiceV1 = RenderModeServiceV1;
//# sourceMappingURL=v1.js.map